import "./home.css";
import Chart from "../../components/chart/Chart";
import FeaturedInfo from "../../components/featuredInfo/FeaturedInfo";
import { userData } from "../../dummyData";
import WidgetSm from "../../components/widgetSm/WidgetSm";
import WidgetLg from "../../components/widgetLg/WidgetLg";
import SetTitle from "../../components/setTitle/SetTitle";
// import {
//   NotificationSnackbarProvider,
//   displayNotification,
// } from "../../components/mui/snackbar/NotificationSnackbarProvider";

import { Link } from "react-router-dom";

export default function Home() {
  SetTitle("DefiWatch.biz - Actual DeFi Performance");

  return (
    <div className="page homePage">
      {/* <FeaturedInfo />
      <Chart
        data={userData}
        title="User Analytics"
        grid
        dataKey="Active User"
      />
      <div className="homeWidgets">
        <WidgetSm />
        <WidgetLg />
      </div> */}

      <div className="featured featuredPromo">
        <div className="featuredItem">
          <img className="featuredImg" src="/img/home/charts.png" />
          <Link to="/charts" className="link">
            <span className="featuredTitle">Historical charts</span>
            {/* <div className="featuredMoneyContainer"> */}
            {/* <span className="featuredMoney">History of each vault</span> */}
            {/* <span className="featuredMoneyRate">
              -11.4 <ArrowDownward className="featuredIcon negative" />
            </span> */}
            {/* </div> */}
            <span className="featuredSub">
              Actual balances, rewards and other data are shown! Not the
              estimated ones as on other platforms!
            </span>
          </Link>
        </div>

        <div className="featuredItem">
          <img className="featuredImg" src="/img/home/portfolio.png" />
          <Link to="/portfolio" className="link">
            <span className="featuredTitle">Your portfolio of investments</span>
            {/* <div className="featuredMoneyContainer">
              <span className="featuredMoney">Your investments</span>
            </div> */}
            <span className="featuredSub">
              Structure and details of your actual DeFi investments at this
              moment
            </span>
          </Link>
        </div>

        <div className="featuredItem">
          <img className="featuredImg" src="/img/home/balances2.png" />
          <Link to="/wallets/balances" className="link">
            <span className="featuredTitle">Balances of coins in wallets</span>
            {/* <div className="featuredMoneyContainer">
              <span className="featuredMoney">Tokens in your wallets</span>
            </div> */}
            <span className="featuredSub">
              The most popular tokens in your wallets at this moment
            </span>
          </Link>
        </div>

        <div className="featuredItem">
          <img className="featuredImg" src="/img/home/alerts.png" />
          <Link to="/account/alerts" className="link">
            <span className="featuredTitle">Track Data Events with Alerts</span>
            {/* <div className="featuredMoneyContainer">
              <span className="featuredMoney">Tracked Data Events</span>
            </div> */}
            <span className="featuredSub">
              Interval based notifications when the investment meets your custom
              criteria
            </span>
          </Link>
        </div>

        <div className="featuredItem">
          <img className="featuredImg" src="/img/home/vaults.png" />
          <Link to="/vaults" className="link">
            <span className="featuredTitle">Tracked Vaults</span>
            {/* <div className="featuredMoneyContainer">
              <span className="featuredMoney">Tracked Vaults</span>
            </div> */}
            <span className="featuredSub">
              Balances, rewards and other data are pulled up from
            </span>
          </Link>
        </div>

        <div className="featuredItem">
          <img className="featuredImg" src="/img/home/wallets5.png" />
          <Link to="/wallets" className="link">
            <span className="featuredTitle">Tracked Wallets</span>
            {/* <div className="featuredMoneyContainer">
              <span className="featuredMoney">Tracked Wallets</span>
            </div> */}
            <span className="featuredSub">
              You can track both your own and other people's wallets
            </span>
          </Link>
        </div>
      </div>

      {/* <NotificationSnackbarProvider>
        <button onClick={displayNotification(["Msg1", "Msg2"])}>Display</button>
      </NotificationSnackbarProvider> */}
    </div>
  );
}
